const TINNITUS_REFRESH_GAIN_DB = 3;

const safeNumber = (value, fallback = null) => {
  const n = Number(value);
  return Number.isFinite(n) ? n : fallback;
};
export function getCanonicalTinnitusProfile({
  equalizerSettings = null,
  labProgram = null,
} = {}) {
  const frequency =
    labProgram?.f_t ||
    equalizerSettings?.inverse_notch?.center_frequency ||
    equalizerSettings?.tinnitus_frequency ||
    null;

  const rawGain =
    labProgram?.gain_db ??
    equalizerSettings?.inverse_notch?.gain ??
    equalizerSettings?.tinnitus_gain ??
    equalizerSettings?.tinnitus_level ??
    null;

  const gain =
    rawGain !== null && rawGain !== undefined
      ? Math.min(Math.abs(safeNumber(rawGain, 0)), TINNITUS_REFRESH_GAIN_DB)
      : frequency
        ? TINNITUS_REFRESH_GAIN_DB
        : null;

  const bandwidth =
    equalizerSettings?.inverse_notch?.bandwidth ??
    labProgram?.bandwidth ??
    null;

  const hasTest = Boolean(
    Number(frequency) > 0 ||
    equalizerSettings?.has_inverse_notch ||
    equalizerSettings?.inverse_notch ||
    labProgram?.enabled
  );

  return {
    hasTest,
    frequency: Number(frequency) > 0 ? Number(frequency) : null,
    gain: gain !== null && gain !== undefined ? Number(gain) : null,
    bandwidth: bandwidth !== null && bandwidth !== undefined ? Number(bandwidth) : null,
    source: labProgram?.f_t
      ? 'lab_program'
      : equalizerSettings?.inverse_notch?.center_frequency
        ? 'inverse_notch'
        : equalizerSettings?.tinnitus_frequency
          ? 'legacy_tinnitus_frequency'
          : hasTest
            ? 'flag_only'
            : 'none',
  };
}